import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {useAuth} from '../../../../../app/modules/auth'

export function CanteenMenu(): JSX.Element {
  const {t} = useTranslation()
  const {hasPermission} = useAuth()
  const base = '/canteen/'

  const menuItems = useMemo(
    () => [
      {permission: null, title: t('MENU.HOME'), to: `${base}home`},
      {permission: 'canteen-item-list', title: t('MENU.CANTEEN_ITEM'), to: `${base}item`},
      {
        permission: 'canteen-item-stock-list',
        title: t('MENU.CANTEEN_ITEM_STOCK'),
        to: `${base}item-stock`,
      },

      {
        permission: 'canteen-purchase-create',
        title: t('MENU.PURCHASE'),
        to: '',
        children: [
          {
            permission: 'canteen-purchase-create',
            title: t('MENU.PURCHASE'),
            to: `${base}purchase-create/0`,
            fontIcon: 'fas fa-file-invoice',
          },
          {
            permission: 'canteen-purchase-list',
            title: t('MENU.PURCHASE_LIST'),
            to: `${base}purchase-list`,
            fontIcon: 'fas fa-list',
          },
        ],
      },
      {
        permission: 'canteen-sale-create',
        title: t('MENU.SALE'),
        to: '',
        children: [
          {
            permission: 'canteen-sale-create',
            title: t('MENU.SALE'),
            to: `${base}sale-create/0`,
            fontIcon: 'fas fa-cash-register',
          },
          {
            permission: 'canteen-sale-list',
            title: t('MENU.SALE_LIST'),
            to: `${base}sale-list`,
            fontIcon: 'fas fa-list',
          },
        ],
      },
      {
        permission: 'canteen-sale-view',
        title: t('MENU.REPORT'),
        to: '',
        children: [
          {
            permission: 'canteen-purchase-report',
            title: t('MENU.PURCHASE_REPORT'),
            to: `${base}purchase-report`,
            fontIcon: 'fas fa-file-invoice',
          },
          {
            permission: 'canteen-sale-report',
            title: t('MENU.SALE_REPORT'),
            to: `${base}sale-report`,
            fontIcon: 'fas fa-cash-register',
          },
        ],
      },
      {
        permission: 'canteen-item-cash-transfer',
        title: t('MENU.CASH_TRANSFER'),
        to: `${base}cash-transfer-list`,
      },
    ],
    [t]
  )

  const renderEntry = (item: any, index: any) => {
    if (item.permission && !hasPermission(item.permission)) return null

    if (item.children) {
      const visibleChildren = item.children.filter(
        (c: any) => !c.permission || hasPermission(c.permission)
      )
      if (!visibleChildren.length) return null

      return (
        <MenuInnerWithSub
          key={index}
          title={item.title}
          to={item.to}
          menuPlacement='bottom-start'
          menuTrigger='click'
          hasArrow={false}
        >
          {visibleChildren.map((child: any, index: any) => (
            <MenuItem key={index} to={child.to} title={child.title} fontIcon={child.fontIcon} />
          ))}
        </MenuInnerWithSub>
      )
    }

    return <MenuItem key={item.to} title={item.title} to={item.to} />
  }

  return <>{menuItems.map(renderEntry)}</>
}
